import * as React from "react"

const ArrowRight = (props) => (
  <svg
    width={6}
    height={8}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.66 4 .874 6.784l.795.796L5.25 4 1.67.42l-.795.796L3.659 4Z"
      fill="currentColor"
    />
  </svg>
)

export default ArrowRight
